import React, {useContext, useState} from 'react'
import {useTranslation} from "react-i18next";
import DataList from "common/src/components/widget/DataList";
import {useModal} from "../../../../context/ModalProvider";
import GroupServiceAccountFormModal from "./GroupServiceAccountFormModal";
import {fetchServiceAccountsPage} from "../../../../state/api/serviceAccountAPI";
import {UserContext} from "../../../../context/UserContext";
import {hasRole} from "../../../../utils/userUtils";
import {Role} from "../../../../auth/roles";

function ServiceAccountsForGroupList({group}) {
    const {t} = useTranslation();
    const {user} = useContext(UserContext);
    const [uuidState, setUuidState] = useState(group.id);
    const {openModal, closeModal} = useModal();

    const handleOpenModal = (serviceAccount) => {
        if (!serviceAccount) {
            console.error("Service Account is required");
        }
        if (!group) {
            console.error("Group is required");
        }
        openModal({
            body: (
                <GroupServiceAccountFormModal
                    serviceAccount={serviceAccount}
                    group={group}
                    onSave={(save) => {
                        closeModal();
                        setUuidState(save.toString() + serviceAccount.id);
                    }}
                    onClose={closeModal}
                />
            ),
            foot: (<></>),
            title: 'Group Service Account',
            backdropClose: false // Set to false to prevent closing on backdrop click
        });
    };

    if (!group || !group.id) {
        return <></>
    }

    return <DataList
        cardTitle={t('service_account.service_accounts')}
        selector={(state) => state.serviceAccountAPI.page}
        refreshState={uuidState}
        loadingSelector={(state) => state.serviceAccountAPI.loading}
        fetchAction={fetchServiceAccountsPage}
        columns={[
            {name: t('service_account.name'), id: "name"},
            {name: t('service_account.isActive'), id: "isActive", sortId: "enabled"}
        ]}
        defaultFilter={"filter=group.id:EQ:" + group.id}
        defaultSort={"sort=name,asc"}
        showCreateButton={hasRole(user, Role.ADMIN_GROUPS)}
        onCreateClick={() => {
            handleOpenModal({groupId: group.id});
        }}
        onClick={(serviceAccount) => {
            if (!serviceAccount) {
                closeModal();
            } else {
                handleOpenModal(serviceAccount);
            }
        }}
    />
}

export default ServiceAccountsForGroupList;
